
export enum THEME_AVAILABILITY {
    HomeWork,
    DateTime,
    Manual
}

export const THEME_OPTIONS = [
    { label: "После успешного выполнения домашней работы", value: THEME_AVAILABILITY.HomeWork},
    { label: "Перед началом занятия", value: THEME_AVAILABILITY.DateTime},
    { label: "Ручное управление доступностью", value: THEME_AVAILABILITY.Manual},
]
export enum THEME_AVAILABILITY {
    HomeWork,
    DateTime,
    Manual
}

export const THEME_OPTIONS = [
    { label: "После успешного выполнения домашней работы", value: THEME_AVAILABILITY.HomeWork},
    { label: "Перед началом занятия", value: THEME_AVAILABILITY.DateTime},
    { label: "Ручное управление доступностью", value: THEME_AVAILABILITY.Manual},
]